import { mdiBinoculars } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const Binoculars = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid={'IconButton__Binoculars'}
            path={mdiBinoculars}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Binoculars
